import { down } from "styled-breakpoints"
import styled from "styled-components"
import ActionButton from "./ActionButton"
import Content from "./Content"
import ProgressBar from "./ProgressBar"
import { steps } from "./data"

interface LayoutProps {
  children: React.ReactNode
  className?: string
  stepData?: any
  currentStep: number
  setCurrentStep(step: number): void
  currentOptions: number
  setCurrentOptions(option: number): void
  onNextStep: () => void
  onPreviousStep: () => void
  onSkipStep: () => void
  onAddToCart: () => void
}

const Container = styled.div`
  &.last-step .action-buttons,
  &.last-step .mobile-buttons {
    padding-right: 50px;
  }

  .action-buttons {
    ${down("tabletLarge")} {
      display: none;
    }
  }

  @media screen and (min-width: 700px) and (max-width: 768px) {
    overflow: hidden;
  }
`

const GridButtons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-areas: "previous skip next";
  gap: 16px;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  width: 100%;
  padding: 0 20px;

  .previous {
    grid-area: previous;
    justify-self: start;
  }
  .next {
    grid-area: next;
    justify-self: end;
  }
  .skip {
    grid-area: skip;
    justify-self: center;
  }
`

const Buttons = styled.div`
  display: flex;
  position: absolute;
  right: max(25%, 550px);
  z-index: 999;
  bottom: 50px;
  gap: 10px;
  width: calc(100% - 550px);
  justify-content: space-between;

  .previous {
    padding-left: 50px;
  }

  .next-skip {
    display: flex;
    justify-self: end;
    gap: 10px;
  }

  .next-btn {
    background-color: #ff0000;
    color: white;
  }

  .skip-btn {
    color: #ff0000;
  }

  @media (max-width: 2560px) {
  }

  @media (max-width: 1440px) {
    width: calc(100% - 450px);
    right: 450px;
  }

  @media (max-width: 1024px) {
    width: calc(100% - 450px);
    right: 450px;
  }

  @media (max-width: 500px) {
    display: none;
  }
`

export default function ConfiguratorLayout({
  children,
  className,
  currentStep,
  currentOptions,
  setCurrentOptions,
  setCurrentStep,
  onNextStep,
  onPreviousStep,
  onSkipStep,
  stepData = undefined,
  onAddToCart,
}: LayoutProps) {
  function handleOptionChange(option: number) {
    setCurrentOptions(option)
  }

  function handleStepChange(stepIndex: number) {
    setCurrentStep(stepIndex)
  }

  return (
    <Container
      className={
        className + (currentStep == steps.length - 1 ? " last-step" : "")
      }
    >
      <ProgressBar
        steps={stepData || steps}
        currentStep={currentStep}
        currentOptions={currentOptions}
        handleOptionChange={handleOptionChange}
        expandedStep={currentStep}
        active={currentStep}
        expanded={currentStep}
        handleStepChange={handleStepChange}
      />
      <Content children={children} currentStep={currentStep} />

      {currentStep !== steps.length - 1 && (
        <Buttons className="action-buttons">
          {currentStep >= 1 ? (
            <div className="previous">
              <ActionButton onClick={onPreviousStep} label="Previous" />
            </div>
          ) : (
            <div></div>
          )}
          {currentStep < steps.length - 1 ? (
            <div className="next-skip">
              <ActionButton
                onClick={onNextStep}
                label="Next"
                className="next next-btn"
              />
            </div>
          ) : (
            <ActionButton
              onClick={onAddToCart}
              label="Add to Cart"
              className="next next-btn"
            />
          )}
        </Buttons>
      )}
    </Container>
  )
}
